export const IconAnalytics20: {
  name: 'icon_analytics_20-e3599a228fad'
} = {
  name: 'icon_analytics_20-e3599a228fad'
}
